'use strict';

(function() {
	angular.module('onboarding.carrier')
		.directive('cobCarrierProfileInsurance', cobCarrierProfileInsurance);

	cobCarrierProfileInsurance.$inject = [
		'$timeout', 'sessionService', 'subjectObserverMessagesService', 'observerService', 'carrierRegistrationService', '$stateParams'
	];

	var $timeout, sessionService, subjectObserverMessagesService, observerService, carrierRegistrationService, $stateParams;
	var subjectMessages, observerMessages;

	function cobCarrierProfileInsurance(_$timeout_,
		_sessionService_,
		_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$stateParams_) {
		$timeout = _$timeout_;
		sessionService = _sessionService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		carrierRegistrationService = _carrierRegistrationService_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/carrier/profile/carrierProfileInsurance.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {};

			loadData();
			registerObserverHandlers();
			document.title = 'Profile-Insurance';

			$timeout(function() {
				observerService.sendMessageToSubject(scope, subjectMessages.COB_SUBJECT_CARRIER_PROFILE_VIEW_LOAD);
				loadData();
			},
			100);
		}

		function loadData() {

			carrierRegistrationService.lookupInsuranceInformation($stateParams.carrierId)
				.then(function(response) {
					if (response.data.isRegistryInsurance) {
						var regInsurance = {
							agents: response.data
						};
						if (sessionService.getBrokerBranding()) {
							regInsurance.insuranceMessage = sessionService.getBrokerBranding().insuranceMessage;
							regInsurance.brokerName = sessionService.getBrokerBranding().brokerName;
						}
						observerService.sendMessageToSubject(scope,
							subjectMessages.COB_SUBJECT_CARRIER_PROFILE_INSUREANCE_REG_LOADED,
							regInsurance);
					} else {
						var dobInsurance = {
							agents: response.data.agents
						};
						if (sessionService.getBrokerBranding()) {
							dobInsurance.insuranceMessage = sessionService.getBrokerBranding().insuranceMessage;
							dobInsurance.brokerName = sessionService.getBrokerBranding().brokerName;
						}
						observerService.sendMessageToSubject(scope,
							subjectMessages.COB_SUBJECT_CARRIER_PROFILE_INSUREANCE_DOB_LOADED,
							dobInsurance);
					}
				});
		}

		function registerObserverHandlers() {

			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_CARRIER_PROFILE_INSUREANCE_RELOAD, handler: loadData }
				]);
		}
	}

})();
